import React, { useState } from "react";
import DisplayBookData from "./DisplayBookData";
import EnterIsbns from "./EnterIsbns";

const ModalSequence = ({
    resetModal,
    wishlistName,
    isbnNameSingular,
    isbnNamePlural,
    maxIsbns,
}) => {
    const nextPage = () => {
        setCurrentPageIndex(currentPageIndex + 1);
    };
    const previousPage = () => {
        setCurrentPageIndex(currentPageIndex - 1);
    };
    const resetSequence = () => {
        setCurrentPageIndex(0);
        setModalState(defaultState);
        resetModal();
    };
    const defaultState = {
        isbnText: "",
        cleanedIsbns: [],
        validIsbnData: {},
    };

    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const [modalState, setModalState] = useState(defaultState);
    const modalPages = [
        <EnterIsbns
            isbnText={modalState.isbnText}
            setIsbnBookData={(isbnRawText, cleanedIsbns, bookData) => {
                setModalState({
                    ...modalState,
                    isbnText: isbnRawText,
                    cleanedIsbns,
                    validIsbnData: bookData,
                });
                nextPage();
            }}
            isbnNamePlural={isbnNamePlural}
            maxIsbns={maxIsbns}
        />,
        <DisplayBookData
            previousPage={previousPage}
            allIsbns={modalState.cleanedIsbns}
            bookData={modalState.validIsbnData}
            reset={() => {
                resetSequence();
            }}
            wishlistName={wishlistName}
            isbnNameSingular={isbnNameSingular}
        />,
    ];

    return modalPages[currentPageIndex];
};

export default ModalSequence;



// WEBPACK FOOTER //
// ./src/components/modal-page/ModalSequence.js